{
  "v4.documents1.adresse_invalide": "Invalid address: the requested object cannot be found.",
  "v4.documents1.annuler": "Cancel",
  "v4.documents1.classement.aucun_element": "No item carries this classification.",
  "v4.documents1.classement.confirmer": "I confirm the deletion of “{{nom}}”",
  "v4.documents1.classement.couleur": "Colour",
  "v4.documents1.classement.couleur_etiquette": "Colour applies to labels only.",
  "v4.documents1.classement.couleurs.amber": "Amber",
  "v4.documents1.classement.couleurs.blue": "Blue",
  "v4.documents1.classement.couleurs.emerald": "Emerald",
  "v4.documents1.classement.couleurs.pink": "Pink",
  "v4.documents1.classement.couleurs.red": "Red",
  "v4.documents1.classement.couleurs.slate": "Slate",
  "v4.documents1.classement.couleurs.violet": "Violet",
  "v4.documents1.classement.date_prevue": "Planned date",
  "v4.documents1.classement.effet_confirmation": "Deletion requires confirmation.",
  "v4.documents1.classement.effet_nombre": "{{n}} item(s) will lose this classification; no item is deleted.",
  "v4.documents1.classement.elements": "Attached items",
  "v4.documents1.classement.enregistrer_libelle": "Save the name",
  "v4.documents1.classement.enregistrer_version": "Save the target version",
  "v4.documents1.classement.libelle": "Name",
  "v4.documents1.classement.libelle_enregistre": "Name saved; identity and attachments kept.",
  "v4.documents1.classement.libelle_requis": "The name is required.",
  "v4.documents1.classement.livree": "Delivered",
  "v4.documents1.classement.nature": "Kind",
  "v4.documents1.classement.natures.composant": "Section",
  "v4.documents1.classement.natures.etiquette": "Label",
  "v4.documents1.classement.natures.version": "Target version",
  "v4.documents1.classement.nom_version": "Version name",
  "v4.documents1.classement.nombre": "Attached items: {{n}}",
  "v4.documents1.classement.non_livree": "Not delivered",
  "v4.documents1.classement.pas_preuve": "Marking “delivered” is not proof of delivery.",
  "v4.documents1.classement.quoi": "the classification",
  "v4.documents1.classement.renommer": "Rename",
  "v4.documents1.classement.renommer_version": "A target version is renamed in its own section.",
  "v4.documents1.classement.retour": "All project classification",
  "v4.documents1.classement.statut": "Status",
  "v4.documents1.classement.suppression": "Deletion",
  "v4.documents1.classement.supprime": "Classification deleted; items are kept.",
  "v4.documents1.classement.supprimer_etiquette": "Delete the label",
  "v4.documents1.classement.supprimer_rubrique": "Delete the section",
  "v4.documents1.classement.supprimer_version_cible": "Delete the target version",
  "v4.documents1.classement.titre": "Classification page",
  "v4.documents1.classement.titre_objet.composant": "Section — {{nom}}",
  "v4.documents1.classement.titre_objet.etiquette": "Label — {{nom}}",
  "v4.documents1.classement.titre_objet.version": "Target version — {{nom}}",
  "v4.documents1.classement.uniquement_version": "For target versions only.",
  "v4.documents1.classement.version_cible": "Target version",
  "v4.documents1.classement.version_enregistree": "Target version saved.",
  "v4.documents1.code.AI_KILL_SWITCH_ACTIVE": "AI is stopped: the job is not sent.",
  "v4.documents1.code.ALREADY_DECIDED": "This decision has already been made.",
  "v4.documents1.code.ALREADY_REVIEWED": "A review has already been filed on this version.",
  "v4.documents1.code.AMONT_CLASSEMENT_NOM_PRIS": "This name is already taken in the project.",
  "v4.documents1.code.AMONT_DEROGATION_DEJA_DECIDEE": "The waiver is already decided: it can no longer be withdrawn.",
  "v4.documents1.code.AMONT_DOCUMENT_DEJA_PUBLIE": "This version is already published.",
  "v4.documents1.code.AMONT_DOCUMENT_NON_APPROUVE": "The version is not approved: it cannot be published.",
  "v4.documents1.code.AMONT_PREUVE_INCOMPATIBLE": "This evidence does not match the version.",
  "v4.documents1.code.AMONT_PRODUCTION_INCONNUE": "This production does not exist in the project model.",
  "v4.documents1.code.AMONT_PUBLICATION_AUTOMATIQUE": "This version is published automatically.",
  "v4.documents1.code.AMONT_RETRAIT_AUTEUR_SEUL": "Only the author of the request can withdraw it.",
  "v4.documents1.code.AMONT_SOURCE_NON_APPROUVEE": "The source is not approved.",
  "v4.documents1.code.AMONT_VERSION_NON_ABANDONNABLE": "This version cannot be abandoned (approved or published).",
  "v4.documents1.code.APPROVAL_REQUIRES_INDEPENDENT_REVIEW": "An independent review is required before the decision.",
  "v4.documents1.code.CORE_UNAVAILABLE": "AI is stopped or unavailable: the job is not sent.",
  "v4.documents1.code.CREATEUR_N_APPROUVE_PAS": "The person who created this document does not decide on it: someone else does.",
  "v4.documents1.code.DROIT_NON_TENU": "You do not hold the right required for this action.",
  "v4.documents1.code.NOT_FOUND": "Object not found in this project.",
  "v4.documents1.code.POINT_DUPLICATE": "This question already exists on this document.",
  "v4.documents1.code.RELECTEUR_NE_DECIDE_PAS": "The person who reviewed this document does not decide on it.",
  "v4.documents1.code.RESOURCE_UNAVAILABLE": "This object does not exist or is no longer accessible in this project.",
  "v4.documents1.code.RISK_APPROVAL_REQUIRES_JUSTIFICATION": "A justification is required for this verdict.",
  "v4.documents1.code.RISK_MITIGATION_REQUIRES_RISK_VERDICT": "A mitigation plan requires a “risk” verdict.",
  "v4.documents1.code.SPEC_CHANGE_ALREADY_OPEN": "A revision proposal is already open on this document.",
  "v4.documents1.code.SPEC_CHANGE_NOT_FOUND": "This revision proposal cannot be found in the project.",
  "v4.documents1.code.SPEC_GATE_EVIDENCE_UNAVAILABLE": "Evidence is not available for this version.",
  "v4.documents1.code.SPEC_NOT_PUBLISHED": "The specification is approved but not published yet: generation waits for its publication.",
  "v4.documents1.code.VALIDATION_ERROR": "Input rejected: check the required fields.",
  "v4.documents1.code.VALIDATION_PAR_UN_TIERS": "Someone other than the author must perform this action.",
  "v4.documents1.code.VERSION_CONFLICT": "Another version was saved in the meantime: reload before trying again.",
  "v4.documents1.code.WAIVER_ALREADY_REVIEWED": "This waiver has already been reviewed.",
  "v4.documents1.code.WAIVER_NOT_ACTIVE": "This waiver is no longer active (withdrawn or closed): it can no longer be reviewed or withdrawn.",
  "v4.documents1.code_historique": "Legacy code: {{code}}",
  "v4.documents1.confirmer.approuvee": "Version approved.",
  "v4.documents1.confirmer.approuver": "Confirm approval",
  "v4.documents1.confirmer.auteur": "Author: {{nom}}",
  "v4.documents1.confirmer.autre_personne": "The author and the reviewer do not decide.",
  "v4.documents1.confirmer.decidee_file": "Decision recorded from the human queue.",
  "v4.documents1.confirmer.file": "Confirm from the human queue",
  "v4.documents1.confirmer.liee_version": "Your attestation is valid for version {{n}} only.",
  "v4.documents1.confirmer.motif_requis": "A reason is required to reject.",
  "v4.documents1.confirmer.recapitulatif": "Summary",
  "v4.documents1.confirmer.rejetee": "Version rejected.",
  "v4.documents1.confirmer.rejeter": "Confirm rejection",
  "v4.documents1.confirmer.relu_repris": "Content read attested for this version.",
  "v4.documents1.confirmer.revenir": "Back to the document",
  "v4.documents1.confirmer.signature_enregistree": "Your signature is recorded; the document stays pending ({{obtenues}} of {{requises}}).",
  "v4.documents1.confirmer.titre": "Confirm the decision",
  "v4.documents1.confirmer.verdict": "Chosen verdict: {{verdict}}",
  "v4.documents1.confirmer.verdicts.approved": "approve",
  "v4.documents1.confirmer.verdicts.rejected": "reject",
  "v4.documents1.confirmer.version_modifiee": "The version changed since your reading: read it again.",
  "v4.documents1.decision.approuver": "Approve…",
  "v4.documents1.decision.commentaire": "Decision comment",
  "v4.documents1.decision.commentaire_aide": "Required to reject.",
  "v4.documents1.decision.deja": "Decision already made by {{par}}.",
  "v4.documents1.decision.refuser": "Reject…",
  "v4.documents1.decision.relecture_requise": "Read the content of this version before deciding.",
  "v4.documents1.decision.relu": "I have read the content of this version",
  "v4.documents1.decisions.a_traiter": "To handle",
  "v4.documents1.decisions.aucun_resultat": "No decision matches the filters.",
  "v4.documents1.decisions.deposer_entree": "Submit an input",
  "v4.documents1.decisions.etat.approuvee": "Approved",
  "v4.documents1.decisions.etat.en_attente": "Pending",
  "v4.documents1.decisions.etat.rejetee": "Rejected",
  "v4.documents1.decisions.etat.remplacee": "Superseded",
  "v4.documents1.decisions.etat.toutes": "All",
  "v4.documents1.decisions.filtre_entree": "Originating input",
  "v4.documents1.decisions.filtre_etape": "Stage",
  "v4.documents1.decisions.filtre_type": "Document type",
  "v4.documents1.decisions.liste": "Project decisions",
  "v4.documents1.decisions.ouvrir": "Open {{titre}}",
  "v4.documents1.decisions.ouvrir_court": "Open",
  "v4.documents1.decisions.pour_moi": "For me",
  "v4.documents1.decisions.pour_un_tiers": "For someone else",
  "v4.documents1.decisions.quoi": "decisions",
  "v4.documents1.decisions.recherche": "Search",
  "v4.documents1.decisions.retour_projet": "Back to the project",
  "v4.documents1.decisions.sans_entree": "No originating input",
  "v4.documents1.decisions.titre": "Decisions to make",
  "v4.documents1.decisions.tous": "All",
  "v4.documents1.decisions.toutes": "All",
  "v4.documents1.decisions.vide": "No decision in this project.",
  "v4.documents1.derogation.aucune_mesure": "No compensating measure.",
  "v4.documents1.derogation.auteur_requis": "Only the author of the request ({{nom}}) can withdraw it, before the decision.",
  "v4.documents1.derogation.avis": "Review opinion",
  "v4.documents1.derogation.avis_aide": "Say whether the compensating measures are sufficient.",
  "v4.documents1.derogation.avis_requis": "The review opinion is required.",
  "v4.documents1.derogation.cible": "Target",
  "v4.documents1.derogation.confirmer_retrait": "I confirm the withdrawal of my request",
  "v4.documents1.derogation.decision": "Decision",
  "v4.documents1.derogation.decision_organisation": "The decision belongs to the organisation only.",
  "v4.documents1.derogation.defavorable": "Unfavourable",
  "v4.documents1.derogation.demandeur": "Requester",
  "v4.documents1.derogation.demandeur_ne_tranche": "The requester never decides on their own waiver.",
  "v4.documents1.derogation.detail": "Details at the organisation",
  "v4.documents1.derogation.droit_non_herite": "A project right does not give the right to decide at organisation level.",
  "v4.documents1.derogation.echeance": "Due date",
  "v4.documents1.derogation.enregistrer_relecture": "Save the review",
  "v4.documents1.derogation.etat.a_decider_organisation": "Reviewed, to be decided by the organisation",
  "v4.documents1.derogation.etat.a_relire": "To review",
  "v4.documents1.derogation.etat.accordee": "Granted",
  "v4.documents1.derogation.etat.echue": "Expired",
  "v4.documents1.derogation.etat.levee": "Lifted",
  "v4.documents1.derogation.etat.refusee": "Refused",
  "v4.documents1.derogation.etat.retiree": "Withdrawn",
  "v4.documents1.derogation.evenement.decision": "Organisation decision",
  "v4.documents1.derogation.evenement.demande": "Request",
  "v4.documents1.derogation.evenement.fin_d_effet": "End of effect",
  "v4.documents1.derogation.evenement.relecture": "Review",
  "v4.documents1.derogation.evenement.retrait": "Withdrawal",
  "v4.documents1.derogation.favorable": "Favourable",
  "v4.documents1.derogation.fiche": "Waiver",
  "v4.documents1.derogation.historique": "History",
  "v4.documents1.derogation.mesures": "Compensating measures",
  "v4.documents1.derogation.nature": "Kind",
  "v4.documents1.derogation.natures.charte": "Charter",
  "v4.documents1.derogation.natures.critere": "Criterion",
  "v4.documents1.derogation.porteur": "Owner",
  "v4.documents1.derogation.quoi": "the waiver",
  "v4.documents1.derogation.relecture": "Review",
  "v4.documents1.derogation.relue": "Review saved; it does not decide the waiver.",
  "v4.documents1.derogation.retiree": "Request withdrawn.",
  "v4.documents1.derogation.retirer": "Withdraw the request",
  "v4.documents1.derogation.retour": "Back",
  "v4.documents1.derogation.retrait": "Withdrawal of the request",
  "v4.documents1.derogation.sans_echeance": "No due date (allowed)",
  "v4.documents1.derogation.suivre": "Follow at the organisation",
  "v4.documents1.derogation.surcharge": "Charter override",
  "v4.documents1.derogation.titre": "Project waiver",
  "v4.documents1.derogation.verdict": "Opinion",
  "v4.documents1.design.apercus": "Previews",
  "v4.documents1.design.aucun_parcours": "No flow in this project.",
  "v4.documents1.design.aucun_parcours_valide": "No validated flow.",
  "v4.documents1.design.aucun_test": "No usability test planned.",
  "v4.documents1.design.aucune_charte": "No project-specific charter.",
  "v4.documents1.design.aucune_comparaison": "No comparison.",
  "v4.documents1.design.charte_version": "Charter {{semver}} — {{etat}}",
  "v4.documents1.design.charte_visee": "Target charter",
  "v4.documents1.design.chartes": "charters",
  "v4.documents1.design.comparaison_lancee": "Comparison started.",
  "v4.documents1.design.comparaisons": "comparisons",
  "v4.documents1.design.comparer": "Compare with the wireframe",
  "v4.documents1.design.conformite": "conformance",
  "v4.documents1.design.couple": "Comparing flow version {{n}} with revision {{revision}}.",
  "v4.documents1.design.critere": "Targeted usability criterion",
  "v4.documents1.design.document_source": "Source document",
  "v4.documents1.design.ecarts": "Token deviations: {{n}}",
  "v4.documents1.design.effective": "Effective charter: {{version}} ({{source}})",
  "v4.documents1.design.etat_flux.a_valider": "to validate",
  "v4.documents1.design.etat_flux.propose": "proposed",
  "v4.documents1.design.etat_flux.remplace": "superseded",
  "v4.documents1.design.etat_flux.valide": "validated",
  "v4.documents1.design.heritage": "charter inheritance",
  "v4.documents1.design.maquette_manquante": "Wireframe missing",
  "v4.documents1.design.onglet.charte": "Charter",
  "v4.documents1.design.onglet.conformite": "Conformance",
  "v4.documents1.design.onglet.parcours": "Flows",
  "v4.documents1.design.onglet.tests_usage": "Usability tests",
  "v4.documents1.design.onglets": "Design sections",
  "v4.documents1.design.ouvrir": "Open",
  "v4.documents1.design.ouvrir_charte": "Open charter {{semver}}",
  "v4.documents1.design.ouvrir_parcours": "Open flow version {{n}}",
  "v4.documents1.design.par_defaut": "default",
  "v4.documents1.design.parcours": "flows",
  "v4.documents1.design.parcours_a_comparer": "Flow to compare",
  "v4.documents1.design.parcours_version": "Flow version {{n}} — {{etat}}",
  "v4.documents1.design.participants": "Participants (3 to 5)",
  "v4.documents1.design.preparer_charte": "Prepare a charter",
  "v4.documents1.design.prevoir": "Plan the usability test",
  "v4.documents1.design.profil": "Participant profile",
  "v4.documents1.design.proposer": "Propose a flow",
  "v4.documents1.design.proposition_lancee": "Proposal started.",
  "v4.documents1.design.provenance_organisation": "Inherited from the organisation.",
  "v4.documents1.design.releve_indisponible": "Survey unavailable for this revision.",
  "v4.documents1.design.revision": "Built revision",
  "v4.documents1.design.revision_requise": "Choose a revision to see its conformance.",
  "v4.documents1.design.scenario": "Scenario",
  "v4.documents1.design.selection_incomplete": "Choose a validated flow and a revision.",
  "v4.documents1.design.solliciter_surcharge": "Request an override",
  "v4.documents1.design.source.default": "default",
  "v4.documents1.design.source.organisation": "organisation",
  "v4.documents1.design.source.override": "overridden",
  "v4.documents1.design.source.project": "project",
  "v4.documents1.design.surcharge_accordee": "Override granted.",
  "v4.documents1.design.surcharge_echue": "Override expired: the organisation charter applies again.",
  "v4.documents1.design.surcharge_en_attente": "Override pending.",
  "v4.documents1.design.taches": "Tasks (one per line, 1 to 10)",
  "v4.documents1.design.test_prevu": "Usability test planned.",
  "v4.documents1.design.tests_usage": "usability tests",
  "v4.documents1.design.titre": "Product design",
  "v4.documents1.design.titre_test": "Title",
  "v4.documents1.design.version_validee": "Validated version {{n}}",
  "v4.documents1.document.abandon_ferme": "Abandonment closed: the version is approved.",
  "v4.documents1.document.abandon_masque": "An approved or published version cannot be abandoned.",
  "v4.documents1.document.abandonnee": "Version abandoned; it stays in the history.",
  "v4.documents1.document.abandonnee_mention": "abandoned (kept in the history)",
  "v4.documents1.document.abandonner": "Abandon version {{n}}",
  "v4.documents1.document.ajouts": "Additions",
  "v4.documents1.document.aucune_difference": "No difference between these versions.",
  "v4.documents1.document.auteur_approbateurs": "Author and approvers",
  "v4.documents1.document.changements": "Changes: {{n}}",
  "v4.documents1.document.choisir": "— Choose —",
  "v4.documents1.document.choisir_deux": "Choose two versions to compare.",
  "v4.documents1.document.comprendre": "Understand and request access",
  "v4.documents1.document.confirmer_abandon": "I confirm the abandonment; the version stays in the history",
  "v4.documents1.document.couverture": "Coverage",
  "v4.documents1.document.differences": "differences",
  "v4.documents1.document.editer": "Edit",
  "v4.documents1.document.empreinte_sortie": "Published fingerprint",
  "v4.documents1.document.etat.approuve": "Approved",
  "v4.documents1.document.etat.aucune": "No current version",
  "v4.documents1.document.etat.brouillon": "Draft",
  "v4.documents1.document.etat.en_relecture": "Under review",
  "v4.documents1.document.etat.publication_en_attente": "Publication pending",
  "v4.documents1.document.etat.publication_en_echec": "Publication failed",
  "v4.documents1.document.etat.publie": "Published",
  "v4.documents1.document.etat.refuse": "Rejected",
  "v4.documents1.document.etat.remplace": "Superseded",
  "v4.documents1.document.fiche": "Document",
  "v4.documents1.document.generer_elements": "Generate items…",
  "v4.documents1.document.gestes": "Actions",
  "v4.documents1.document.meme_version": "Choose two different versions.",
  "v4.documents1.document.non_publie": "Not published yet.",
  "v4.documents1.document.points_bloquants": "Unverified blocking points: {{n}}",
  "v4.documents1.document.preparer_mission": "Prepare a mission",
  "v4.documents1.document.preuve.fraiche": "Evidence fresh.",
  "v4.documents1.document.preuve.perimee": "Evidence stale: re-evaluate it.",
  "v4.documents1.document.preuve.sans": "No evidence attached.",
  "v4.documents1.document.proposer_revision": "Propose a revision…",
  "v4.documents1.document.publication": "Publication",
  "v4.documents1.document.publiee": "Version published.",
  "v4.documents1.document.publier": "Publish version {{n}}",
  "v4.documents1.document.quoi": "the document",
  "v4.documents1.document.raison.auteur_de_la_version": "The author of the version does not publish it; someone else does.",
  "v4.documents1.document.raison.deja_publie": "This version is already published.",
  "v4.documents1.document.raison.droit_non_tenu": "You do not hold the right to publish.",
  "v4.documents1.document.raison.non_approuve": "The version is not approved.",
  "v4.documents1.document.raison.publication_automatique": "This version is published automatically.",
  "v4.documents1.document.reevaluee": "Evidence re-evaluated.",
  "v4.documents1.document.reevaluer": "Re-evaluate the evidence",
  "v4.documents1.document.reference_code": "Code reference",
  "v4.documents1.document.reference_publication": "Publication reference",
  "v4.documents1.document.retour_publies": "Published documents",
  "v4.documents1.document.retour_redaction": "Back to drafting",
  "v4.documents1.document.retraits": "Removals",
  "v4.documents1.document.suite_bloquee": "Next steps (items, mission) wait for publication.",
  "v4.documents1.document.titre": "Document and versions",
  "v4.documents1.document.traiter_points": "Handle the points",
  "v4.documents1.document.type": "Model type",
  "v4.documents1.document.version_comparee": "Compared version",
  "v4.documents1.document.version_depart": "Base version",
  "v4.documents1.document.versions": "Versions",
  "v4.documents1.document.voir_decision": "See the decision",
  "v4.documents1.ecran_non_realise": "“{{ecran}}” is not available yet: this screen comes with a later wave.",
  "v4.documents1.editeur.apercu": "Preview",
  "v4.documents1.editeur.aucune_reponse": "No answer to integrate.",
  "v4.documents1.editeur.contenu": "Document content",
  "v4.documents1.editeur.contenu_vide": "The content is empty.",
  "v4.documents1.editeur.depart": "Starting version",
  "v4.documents1.editeur.edition": "Edit",
  "v4.documents1.editeur.effet_approbation": "No self-approval: someone else decides.",
  "v4.documents1.editeur.effet_conservee": "The previous version stays in the history.",
  "v4.documents1.editeur.effet_nouvelle": "Submitting creates a new, separate version.",
  "v4.documents1.editeur.effet_preuve": "Evidence will be recomputed on the new version.",
  "v4.documents1.editeur.integration_a_verifier": "Integration will be checked on the new version.",
  "v4.documents1.editeur.lecture_seule": "Read only: you do not hold the right to edit.",
  "v4.documents1.editeur.motif": "Reason for the new version",
  "v4.documents1.editeur.non_enregistre": "Unsaved changes.",
  "v4.documents1.editeur.perte_locale": "Your local changes will be lost.",
  "v4.documents1.editeur.reponses": "Answers to integrate",
  "v4.documents1.editeur.saisie": "Editing",
  "v4.documents1.editeur.sans_document": "Choose a document to edit from its page.",
  "v4.documents1.editeur.soumettre": "Submit the new version",
  "v4.documents1.editeur.soumettre_autre": "Submit the new document version",
  "v4.documents1.editeur.soumise": "New version submitted; it awaits someone else’s decision.",
  "v4.documents1.editeur.titre": "Edit a document",
  "v4.documents1.editeur.vers_decisions": "See decisions",
  "v4.documents1.etat.chargement": "Loading: {{quoi}}…",
  "v4.documents1.etat.en_cours": "In progress…",
  "v4.documents1.etat.erreur": "Could not read: {{quoi}}.",
  "v4.documents1.etat.introuvable": "Not found: {{quoi}}.",
  "v4.documents1.etat.reessayer": "Retry",
  "v4.documents1.etat.refus": "Access denied: {{quoi}}.",
  "v4.documents1.etat.vide": "Nothing to show.",
  "v4.documents1.fiche.actualiser": "Refresh",
  "v4.documents1.fiche.auteur": "Author",
  "v4.documents1.fiche.contenu": "Document content",
  "v4.documents1.fiche.date": "Date",
  "v4.documents1.fiche.decider": "Decide",
  "v4.documents1.fiche.document": "Document",
  "v4.documents1.fiche.echanges": "Input exchanges",
  "v4.documents1.fiche.eligibilite": "Eligibility and quorum",
  "v4.documents1.fiche.entree": "Originating input",
  "v4.documents1.fiche.lecture": "Reading mode",
  "v4.documents1.fiche.liens": "Links",
  "v4.documents1.fiche.membres": "Project members",
  "v4.documents1.fiche.mode.registre_technique": "Technical record",
  "v4.documents1.fiche.mode.rendu": "Rendered",
  "v4.documents1.fiche.mode.texte_brut": "Plain text",
  "v4.documents1.fiche.nouvelle_version": "New version",
  "v4.documents1.fiche.points": "Document points",
  "v4.documents1.fiche.preuves": "Evidence",
  "v4.documents1.fiche.quoi": "the document",
  "v4.documents1.fiche.remplacee": "superseded",
  "v4.documents1.fiche.retour_decisions": "Back to decisions",
  "v4.documents1.fiche.retour_entree": "Originating input",
  "v4.documents1.fiche.revue": "Risk and review",
  "v4.documents1.fiche.sans_entree": "Document without an originating input",
  "v4.documents1.fiche.source": "Source",
  "v4.documents1.fiche.source_absente": "No source recorded",
  "v4.documents1.fiche.source_chargee": "Source loaded",
  "v4.documents1.fiche.titre": "Document and decision",
  "v4.documents1.fiche.traitements": "Jobs and productions",
  "v4.documents1.fiche.version": "Version",
  "v4.documents1.fiche.voir_document": "See the document and its versions",
  "v4.documents1.generer.effet_acceptation": "No item is accepted automatically.",
  "v4.documents1.generer.effet_existants": "Existing items are flagged, never overwritten.",
  "v4.documents1.generer.effet_niveaux": "Levels created are those of the project model.",
  "v4.documents1.generer.etat.document_approuve_et_publie": "Document approved and published.",
  "v4.documents1.generer.etat.document_remplace": "Document superseded by a newer version.",
  "v4.documents1.generer.etat.publication_non_terminee": "Publication not finished: generation waits.",
  "v4.documents1.generer.generer": "Generate items",
  "v4.documents1.generer.lancee": "Generation started.",
  "v4.documents1.generer.preuve_fraiche": "Evidence fresh.",
  "v4.documents1.generer.preuve_perimee": "Evidence stale.",
  "v4.documents1.generer.provenance": "Provenance",
  "v4.documents1.generer.sans_preuve": "No evidence.",
  "v4.documents1.generer.titre": "Generate items",
  "v4.documents1.generer.version_empreinte": "Version {{n}} — fingerprint {{empreinte}}",
  "v4.documents1.geste_echec": "The action did not complete. Try again or check the log.",
  "v4.documents1.points.ajoute": "Question added and selected.",
  "v4.documents1.points.ajouter": "Add the question",
  "v4.documents1.points.aucune_selection": "No point selected.",
  "v4.documents1.points.bloquant": "blocking",
  "v4.documents1.points.bloquant_non_atteste": "Blocking point not attested in a version.",
  "v4.documents1.points.etat": "State: {{etat}}",
  "v4.documents1.points.fil.questions": "Open questions",
  "v4.documents1.points.fil.reponses_et_decisions": "Answers and decisions",
  "v4.documents1.points.fil.tout": "All",
  "v4.documents1.points.fil.versions": "Versions",
  "v4.documents1.points.filtre": "Thread",
  "v4.documents1.points.question": "New question",
  "v4.documents1.points.question_aide": "Attached to this decision and version {{n}}.",
  "v4.documents1.points.question_requise": "The question is required.",
  "v4.documents1.points.reporter": "Defer all",
  "v4.documents1.points.reporter_effet": "{{n}} point(s) become “deferred”; each can be reopened individually, with its history.",
  "v4.documents1.points.reporter_n": "Defer the {{n}} open point(s)",
  "v4.documents1.points.reporter_titre": "Defer all open points?",
  "v4.documents1.points.reportes": "{{n}} point(s) deferred.",
  "v4.documents1.points.selectionner": "Select {{code}}",
  "v4.documents1.points.traiter": "Handle the point",
  "v4.documents1.points.vide": "No point on this document.",
  "v4.documents1.preuves.aucun_recu": "No evaluation receipt.",
  "v4.documents1.preuves.comparer": "Compare with the extraction",
  "v4.documents1.preuves.evaluation_demandee": "Evaluation requested.",
  "v4.documents1.preuves.evaluer": "Evaluate the evidence",
  "v4.documents1.preuves.fraiche_jusqu": "Evidence fresh until {{date}}",
  "v4.documents1.preuves.perimee_depuis": "Evidence stale since {{date}}",
  "v4.documents1.preuves.rattachee": "Evidence attached.",
  "v4.documents1.preuves.rattacher": "Attach the evidence",
  "v4.documents1.preuves.recu": "Receipt {{recu}}",
  "v4.documents1.preuves.reference": "Evidence reference",
  "v4.documents1.preuves.reference_aide": "Attached to version {{n}}.",
  "v4.documents1.preuves.reference_requise": "The evidence reference is required.",
  "v4.documents1.preuves.relues": "I have reviewed the evidence of version {{n}}",
  "v4.documents1.preuves.renouvelee": "Evidence renewed.",
  "v4.documents1.preuves.renouveler": "Renew the evidence",
  "v4.documents1.preuves.score": "score {{score}}",
  "v4.documents1.preuves.statut": "Evaluation: {{statut}}",
  "v4.documents1.preuves.vide": "No evidence evaluation for this version.",
  "v4.documents1.production.acteurs": "Produce actors",
  "v4.documents1.production.decomposer": "Break down into items…",
  "v4.documents1.production.document": "Produce the next document",
  "v4.documents1.production.examen_qualite": "Start a quality review",
  "v4.documents1.production.generer_version": "Generate a version",
  "v4.documents1.production.lancee": "Job started.",
  "v4.documents1.production.niveau_superieur": "Produce the upper level",
  "v4.documents1.production.nom_invalide": "Lowercase letters, digits and hyphens; starts with a letter.",
  "v4.documents1.production.nom_technique": "Technical name",
  "v4.documents1.production.options": "Produce options",
  "v4.documents1.production.port": "Listening port",
  "v4.documents1.production.port_invalide": "A port between 1024 and 65535.",
  "v4.documents1.production.processus": "Produce processes",
  "v4.documents1.quorum.createur_ineligible": "You created this document: someone else decides on it.",
  "v4.documents1.quorum.designe": "Signatory designated by the model: {{nom}}",
  "v4.documents1.quorum.eligible": "You can sign this version.",
  "v4.documents1.quorum.raison.createur_n_approuve_pas": "You created this document: someone else decides on it.",
  "v4.documents1.quorum.raison.deja_decidee": "This version is already decided.",
  "v4.documents1.quorum.raison.deja_signee": "You have already signed this version.",
  "v4.documents1.quorum.signatures": "Signatures: {{obtenues}} of {{requises}} required by the model, {{restantes}} remaining",
  "v4.documents1.refus.createur_n_approuve_pas": "The person who created this document does not decide on it: someone else does.",
  "v4.documents1.refus.relecteur_ne_decide_pas": "The person who reviewed this document does not decide on it.",
  "v4.documents1.refus.validation_par_un_tiers": "Someone other than the author must perform this action.",
  "v4.documents1.reviser.deja_ouverte": "A proposal is already open: {{ref}}.",
  "v4.documents1.reviser.immuable": "This version does not change: the revision will produce a new one if accepted.",
  "v4.documents1.reviser.impact": "Impact",
  "v4.documents1.reviser.justification": "Justification",
  "v4.documents1.reviser.majeur": "Major",
  "v4.documents1.reviser.mineur": "Minor",
  "v4.documents1.reviser.minimum": "At least 20 characters.",
  "v4.documents1.reviser.note": "Note (optional)",
  "v4.documents1.reviser.proposee": "Revision proposed.",
  "v4.documents1.reviser.proposer": "Propose the revision",
  "v4.documents1.reviser.titre": "Propose a revision",
  "v4.documents1.reviser.version_visee": "Target version",
  "v4.documents1.revue.deja": "Review already filed: {{verdict}} by {{par}}.",
  "v4.documents1.revue.deposee": "Review filed; it is not a decision.",
  "v4.documents1.revue.deposer": "File the review",
  "v4.documents1.revue.justification": "Review justification",
  "v4.documents1.revue.justification_requise": "The justification is required.",
  "v4.documents1.revue.verdict": "Review verdict",
  "v4.documents1.revue.verdict_requis": "Choose a verdict.",
  "v4.documents1.revue.verdicts.approve": "Favourable",
  "v4.documents1.revue.verdicts.aucun": "— Choose —",
  "v4.documents1.revue.verdicts.reject": "Unfavourable",
  "v4.documents1.revue.verdicts.risk": "Risk",
  "v4.documents1.risque.categorie": "Risk category",
  "v4.documents1.risque.echeance": "Due date",
  "v4.documents1.risque.enregistrer_plan": "Save the plan",
  "v4.documents1.risque.mesure": "Mitigation measure",
  "v4.documents1.risque.niveau.aucun": "— Choose —",
  "v4.documents1.risque.niveau.high": "High",
  "v4.documents1.risque.niveau.low": "Low",
  "v4.documents1.risque.niveau.medium": "Medium",
  "v4.documents1.risque.plan_enregistre": "Mitigation plan saved.",
  "v4.documents1.risque.proprietaire": "Mitigation owner",
  "v4.documents1.risque.relevee": "Category set.",
  "v4.documents1.risque.relever": "Set the category",
  "v4.documents1.sans_projet": "No project open: choose one in the context bar.",
  "v4.documents1.titre_version": "{{titre}} — version {{n}}",
  "v4.documents1.traitements.etat.echec": "failed",
  "v4.documents1.traitements.etat.en_cours": "running",
  "v4.documents1.traitements.etat.en_file": "queued",
  "v4.documents1.traitements.etat.termine": "done",
  "v4.documents1.traitements.quoi": "jobs",
  "v4.documents1.traitements.vide": "No job started from this document.",
  "v4.documents1.version": "Version {{n}}",
  "v4.documents1.version_nouvelle.consigne": "Instruction for the new version",
  "v4.documents1.version_nouvelle.consigne_aide": "It prepares the input; the new version goes back to a decision.",
  "v4.documents1.version_nouvelle.consigne_requise": "Give an instruction or choose at least one answer.",
  "v4.documents1.version_nouvelle.editer": "Edit the document",
  "v4.documents1.version_nouvelle.entree_requise": "This document has no originating input: a new version cannot be requested here.",
  "v4.documents1.version_nouvelle.sollicitee": "New version {{n}} requested.",
  "v4.documents1.version_nouvelle.solliciter": "Request a new version",
  "v4.documents1.version_nouvelle.transmettre": "Send answer {{code}}"
}
